/*
 * participant.js 19.01.18
 *
 * (c) 2018 ergovia GmbH
 */
import {SELECT_PARTICIPANT} from '../actions/types';

const participant = (state = {
    selected: null
}, action) => {

    switch (action.type) {

        case SELECT_PARTICIPANT:

            return {
                selected: action.participant
            };

        default:
            return state;

    }

};

export default participant;



// WEBPACK FOOTER //
// ./src/de/ergovia/reducers/participant.js